import { Box, Button, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks';
import { extendSession } from 'store/sessionReducer';

const formatTime = (seconds: number): string => {
    const min = Math.floor(seconds / 60);
    return `${min}min`;
};

const SessionWarningIndicator = () => {
    const dispatch = useAppDispatch();
    const { showWarning, remainingSeconds, isExtending } = useAppSelector((state) => state.session);

    if (!showWarning || remainingSeconds === null) return null;

    const handleExtend = () => {
        dispatch(extendSession());
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
            <Typography
                variant="body2"
                sx={{
                    color: '#f44336',
                    fontWeight: 700,
                    fontFamily: 'monospace',
                    fontSize: '0.9rem',
                }}
            >
                {formatTime(remainingSeconds)}
            </Typography>
            <Button
                size="small"
                variant="contained"
                color="error"
                onClick={handleExtend}
                disabled={isExtending}
                sx={{ minWidth: 'auto', px: 1.5, py: 0.3, fontSize: '0.75rem' }}
            >
                {isExtending ? '...' : '연장'}
            </Button>
        </Box>
    );
};

export default SessionWarningIndicator;
